const GALLERY_IMAGE_PATH = '/assets/three_d_studio/conference_sign_in_modal'

export const CONFERENCE_PATH = '/guests/sessions/conference'

// Server-side valid_email? is the source of truth; this just avoids obviously-malformed POSTs.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const ERROR_MESSAGES = {
  invalid_email: 'Please enter a valid email address.',
  needs_sign_in: 'An account already exists for this email. Please sign in.',
  not_found: 'Conference sign-up is not available right now.',
  generic: 'Could not sign you in. Please try again.',
}

export const GALLERY_IMAGES = [
  { name: 'popcorn', src: `${GALLERY_IMAGE_PATH}/popcorn.webp`, alt: 'Popcorn model' },
  { name: 'tree', src: `${GALLERY_IMAGE_PATH}/tree.webp`, alt: 'Tree model' },
  { name: 'robot', src: `${GALLERY_IMAGE_PATH}/robot.webp`, isTall: true, alt: 'Robot model' },
  { name: 'motorcycle', src: `${GALLERY_IMAGE_PATH}/motorcycle.webp`, alt: 'Motorcycle model' },
  { name: 'chair', src: `${GALLERY_IMAGE_PATH}/chair.webp`, alt: 'Chair model ' },
]
